import { useCallback, useState } from "react";

/**
 * A hook that persists input value in localStorage
 * @param key The localStorage key to use for persistence
 * @param initialValue Optional initial value if nothing is stored
 * @returns [value, setValue] tuple similar to useState
 */
export function usePersistedInput(key: string, initialValue = ""): [string, (value: string) => void] {
    const [value, setRawValue] = useState<string>(() => {
        if (typeof window !== "undefined") {
            const storedValue = localStorage.getItem(key);
            return storedValue !== null ? storedValue : initialValue;
        }
        return initialValue;
    });

    const setValue = useCallback(
        (value: string) => {
            if (typeof window !== "undefined") {
                localStorage.setItem(key, value);
            }
            setRawValue(value);
        },
        [key],
    );

    return [value, setValue];
}
